/* global globalThis */
// A/B-симуляции: игроки legacy-групп играют по поведению волны 27 —
// изменения волны 28 для них ревертируются точечными гейтами по этому предикату.
// В продакшене набор не задан — все играют по текущему (новому) поведению.
// Волна 27 (5 поведенческих фиксов common_problems_24) запечена как
// безусловная база, прежний гейт isWave25BehaviorPlayer удален.
// (Волна 26 реализовывалась и была полностью откачена — номер пропущен,
// см. developer_artifacts/bot_strategy/simulations/simulation_aggregate_23*.md)
export const isWave27BehaviorPlayer = (playerId) =>
  Boolean(globalThis.__wave27PlayerIds && globalThis.__wave27PlayerIds.has(playerId));

// A/B волны 30 (вайтлист политик WAVE30_POLICY_WHITELIST): игроки этого набора
// играют ПРЕЖНИМ поведением покупки политик (без вайтлиста) — legacy-группа.
// В продакшене набор не задан: вайтлист действует для всех ботов.
export const isPrePolicyWhitelistPlayer = (playerId) =>
  Boolean(globalThis.__prePolicyWhitelistPlayerIds
    && globalThis.__prePolicyWhitelistPlayerIds.has(playerId));

// A/B волны 31 (потолок отрядов при найме): игроки этого набора играют ПРЕЖНИМ
// поведением — UNITS_SAME_TIME_COUNT_LIMIT применяется как общий потолок армии,
// дополнительных слотов инсектоидам и BARBARISM не выдается (legacy-группа).
// В продакшене набор не задан: слоты действуют для всех ботов.
export const isPreRecruitmentCapFixPlayer = (playerId) =>
  Boolean(globalThis.__preRecruitmentCapFixPlayerIds
    && globalThis.__preRecruitmentCapFixPlayerIds.has(playerId));

// A/B волны 32 (улучшения против живых игроков по реплеям прода, независимые
// блоки — факторный дизайн, режим харнесса SIM_W32). Игрок из набора играет
// ПРЕЖНИМ поведением своего блока (legacy). В продакшене наборы не заданы:
// новое поведение действует для всех ботов.
//  - логистика: выход армии за пределы снабжения, шаги по пустым клеткам,
//    срок жизни кампаний, порядок захватных целей;
//  - оборона: угроза городу по реальной досягаемости врага, держатель на
//    квартале угрожаемого города, найм под угрозой;
//  - армия: улучшение отрядов на казарме.
// Волна 32, раунд 3: слоты армии с фермами под нее (A) и докупка размера в
// середине и конце партии (S) удалены вместе с гейтами isPreW32ArmyPlayer и
// isPreW32ArmySpendPlayer (A/B r2: минус по очкам)
// Зонтичный гейт логистики: игрок из набора — legacy по всем подчастям L3-L5
export const isPreW32LogisticsPlayer = (playerId) =>
  Boolean(globalThis.__preW32LogisticsPlayerIds
    && globalThis.__preW32LogisticsPlayerIds.has(playerId));

export const isPreW32DefensePlayer = (playerId) =>
  Boolean(globalThis.__preW32DefensePlayerIds
    && globalThis.__preW32DefensePlayerIds.has(playerId));

// Волна 32, раунд 3: логистика разбита на подчасти для A/B (r2: захваты у игроков
// выросли, но и голод, и потери армии — нужно видеть вклад частей). Подгейт
// legacy, если игрок в своем наборе ИЛИ в зонтичном __preW32LogisticsPlayerIds.
// Волна 32, раунд 4: тюнинг модели марша T удален вместе с гейтом
// isPreW32MarchTunePlayer (A/B r3: −1.3 п.п. винрейта), прежний L1 разделен на
// L1 (коридор) и L2 (дороги кампаний)
// Волна 32, раунд 5: дороги стройки L1 (коридор к живым противникам) и L2 (дороги
// кампаний вне снабжения) удалены вместе с гейтами isPreW32CorridorPlayer и
// isPreW32CampaignRoadPlayer (A/B r4: L1 −0.59 очка, L2 без эффекта) — стройка
// дорог прежняя. Номера L3-L5 сохранены (данные прогонов)
// L3 — марш захватной кампании через разрыв снабжения, тяга возврата в снабжение,
// сохранение захватной кампании у отряда вне снабжения (перемещение и кампании)
export const isPreW32MarchPlayer = (playerId) => isPreW32LogisticsPlayer(playerId)
  || Boolean(globalThis.__preW32MarchPlayerIds
    && globalThis.__preW32MarchPlayerIds.has(playerId));

// L4 — контроль прогресса захватных кампаний: застревание, черный список,
// снятие кампаний у отрядов на жестком казарменном удержании
export const isPreW32StallPlayer = (playerId) => isPreW32LogisticsPlayer(playerId)
  || Boolean(globalThis.__preW32StallPlayerIds
    && globalThis.__preW32StallPlayerIds.has(playerId));

// L5 — порядок захватных целей по досягаемости и гарнизону
export const isPreW32TargetOrderPlayer = (playerId) => isPreW32LogisticsPlayer(playerId)
  || Boolean(globalThis.__preW32TargetOrderPlayerIds
    && globalThis.__preW32TargetOrderPlayerIds.has(playerId));

// Улучшение отрядов (A5): legacy-игрок улучшения волны 32 не делает
export const isPreW32ArmyUpgradePlayer = (playerId) =>
  Boolean(globalThis.__preW32ArmyUpgradePlayerIds
    && globalThis.__preW32ArmyUpgradePlayerIds.has(playerId));

// Волна 32, блок E (экономика: руины стройкой и поздние траты). Игрок из набора —
// ПРЕЖНЕЕ поведение подчасти. Подгейт legacy, если игрок в своем наборе ИЛИ в
// зонтичном __preW32EconomyPlayerIds. В продакшене наборы не заданы
export const isPreW32EconomyPlayer = (playerId) =>
  Boolean(globalThis.__preW32EconomyPlayerIds
    && globalThis.__preW32EconomyPlayerIds.has(playerId));

const isInW32EconomySubset = (setName, playerId) => isPreW32EconomyPlayer(playerId)
  || Boolean(globalThis[setName] && globalThis[setName].has(playerId));

// Волна 32, раунд 5: горизонт дохода ключевых точек в оценке стройки (E1) удален
// вместе с гейтом isPreW32KeyPointHorizonPlayer (A/B r4: −0.55 очка)
// E2 — резерв монет на найм не блокирует присоединение руин
export const isPreW32RuinsReservePlayer = (playerId) =>
  isInW32EconomySubset('__preW32RuinsReservePlayerIds', playerId);
// E3 — цепочка «дорога -> ЦК у руин» в одном ходу
export const isPreW32RuinsChainPlayer = (playerId) =>
  isInW32EconomySubset('__preW32RuinsChainPlayerIds', playerId);
// E4 — новый город с руинами/великим рудником на кольце (продолжение)
export const isPreW32CityFollowUpPlayer = (playerId) =>
  isInW32EconomySubset('__preW32CityFollowUpPlayerIds', playerId);
// E5 — поздняя ценность нового города (платформа и чистая стоимость ЦК)
export const isPreW32LateCityPlayer = (playerId) =>
  isInW32EconomySubset('__preW32LateCityPlayerIds', playerId);
// E6 — цена поздних спецстроений, арсенал в последнем раунде
export const isPreW32LateSpecialsPlayer = (playerId) =>
  isInW32EconomySubset('__preW32LateSpecialsPlayerIds', playerId);
// E7 — храмы крысолюдов, инсектоидов и зверолюдов с 10 раунда
export const isPreW32RushTemplePlayer = (playerId) =>
  isInW32EconomySubset('__preW32RushTemplePlayerIds', playerId);

// A/B волны 33 («сильные города» бонусных ботов LARGE/GREAT): игроки этого
// набора играют ПРЕЖНИМ бонусным поведением (пакет botBonusBehavior волны
// «bonus» без оси удара, кузницы, тыла/фронта ферм и армейской фазы) —
// legacy-группа. В продакшене набор не задан: новое поведение у всех.
export const isPreBonusCitiesPlayer = (playerId) =>
  Boolean(globalThis.__preBonusCitiesPlayerIds
    && globalThis.__preBonusCitiesPlayerIds.has(playerId));

// A/B волны 35 (оборона городов по реплеям прода и замечаниям игроков высокого
// рейтинга, факторный дизайн, режим харнесса SIM_W35). Игрок из набора своего
// признака играет ПРЕЖНИМ поведением этой подчасти (legacy); зонтичный набор
// __preW35PlayerIds — legacy по всем подчастям сразу. В продакшене наборы не
// заданы: новое поведение действует для всех ботов.
const isInW35Subset = (setName, playerId) => Boolean(
  (globalThis.__preW35PlayerIds && globalThis.__preW35PlayerIds.has(playerId))
  || (globalThis[setName] && globalThis[setName].has(playerId))
);
// G — гарнизоны по доктрине фракции («защитный класс» отрядов). Действуют только у
// ботов с бонусом «большой» и выше (checkIfW35GarrisonPlayer в
// evaluation/garrisons.js): у остальных G нет и без этого набора
export const isPreW35GarrisonPlayer = (playerId) => isInW35Subset('__preW35GarrisonPlayerIds', playerId);
// D1 — захват без выживания: бонус захвата снимается при ожидаемом уроне не меньше
// размера, штраф самоубийства и на чужих кварталах.
// Остальные подчасти D («оборона дороже захвата») удалены вместе с гейтами
// isPreW35DefenseValuePlayer (зонтичный D), isPreW35DefenseHolderPlayer (D2),
// isPreW35DefenseTradePlayer (D3) и isPreW35DefenseSoonPlayer (D4) — поведение
// прежнее у всех ботов. A/B 2026-10-26 (r2: 16 032 партии обычных ботов; r3_great:
// 8160 партий, метрики рубиновых): D2 (держатель при NEXT_ROUND — ценность города
// целиком и пол) −0.45 п.п. винрейта (шум) и −0.57 очка; D3 (размен своего
// города на чужой) −0.18 п.п. и −0.64 очка (значимо у обычных); D4 (угроза
// «скоро» в перемещении и бонус держателя при ней) −2.54 п.п. и −2.32 очка
// (значимо). D1 нейтрален (+0.28 п.п., +0.10 очка) и остается под своим гейтом.
// Горизонт «скоро» открытости гарнизонов G и найма R/G не тронут — он часть G и R
export const isPreW35DefenseSuicidePlayer = (playerId) => isInW35Subset('__preW35DefenseSuicidePlayerIds', playerId);
// H — доктрина фракции в выборе архетипа (экономические не уходят в штурм с голым тылом)
export const isPreW35DoctrinePlayer = (playerId) => isInW35Subset('__preW35DoctrinePlayerIds', playerId);
// K — дальность и застревание захватных кампаний
export const isPreW35CampaignRangePlayer = (playerId) => isInW35Subset('__preW35CampaignRangePlayerIds', playerId);
// B — стройка и новые города с учетом риска потерять город
export const isPreW35BuildRiskPlayer = (playerId) => isInW35Subset('__preW35BuildRiskPlayerIds', playerId);
// S — резерв монет армейской фазы бонусных ботов не блокирует всю стройку
export const isPreW35ArmyReservePlayer = (playerId) => isInW35Subset('__preW35ArmyReservePlayerIds', playerId);
// R — найм в конце партии только под цель, до которой отряд успеет, или заслон
export const isPreW35LateHirePlayer = (playerId) => isInW35Subset('__preW35LateHirePlayerIds', playerId);

// A/B волны 36 (боты «золото+»: крупные города вместо колец ферм и казарм у
// центрального квартала, обновление рынка политик под топ-3 фракции; режим
// харнесса SIM_W36). Поведение волны действует только у ботов с бонусом
// «большой» и выше (checkIfW36GoldPlusPlayer в evaluation/goldPlus.js), здесь —
// только legacy-наборы A/B. Игрок из набора своего признака играет ПРЕЖНИМ
// поведением этой подчасти; зонтичный набор __preW36PlayerIds — legacy по всем
// подчастям сразу. В продакшене наборы не заданы: новое поведение у всех
// ботов золото+.
const isInW36Subset = (setName, playerId) => Boolean(
  (globalThis.__preW36PlayerIds && globalThis.__preW36PlayerIds.has(playerId))
  || (globalThis[setName] && globalThis[setName].has(playerId))
);
// C1 — бронь легальных под базовый квартал клеток кольца центрального квартала:
// ферма и казарма туда — в последнюю очередь, пока в городе мало базовых кварталов
export const isPreW36RingReservePlayer = (playerId) => isInW36Subset('__preW36RingReservePlayerIds', playerId);
// C2 — ценность роста города: базовый квартал как площадка под спецстроение по
// доктрине фракции
export const isPreW36QuarterGrowthPlayer = (playerId) => isInW36Subset('__preW36QuarterGrowthPlayerIds', playerId);
// C3 — без «мусорных» казарм: потолок казарм на город, вторая казарма только
// при лагере/арсенале, добор не воскрешает обнуленные постройки
export const isPreW36BarracksCapPlayer = (playerId) => isInW36Subset('__preW36BarracksCapPlayerIds', playerId);
// C4 — плотность своих городов: новый центральный квартал не отнимает места под
// базовые кварталы у своих городов
export const isPreW36CityDensityPlayer = (playerId) => isInW36Subset('__preW36CityDensityPlayerIds', playerId);
// C5 — спецстроения по доктрине: экономические фракции строят храмы и гильдии,
// не гася их разовой сменой архетипа на агрессивный
export const isPreW36DoctrineSpecialsPlayer = (playerId) => isInW36Subset('__preW36DoctrineSpecialsPlayerIds', playerId);
// PT — цели политик: топ-3 рекомендаций фракции для ботов золото+ (вне
// вайтлиста волны 30 — только Теократия, см. configs/botGoldPlus)
export const isPreW36PolicyTargetsPlayer = (playerId) => isInW36Subset('__preW36PolicyTargetsPlayerIds', playerId);
// PR — обновление рынка, пока у бота нет политики и купить с рынка нечего
export const isPreW36MarketRefreshPlayer = (playerId) => isInW36Subset('__preW36MarketRefreshPlayerIds', playerId);
// PW — обновление рынка вместо покупки слабой политики в начале партии
export const isPreW36RefreshOverWeakPlayer = (playerId) => isInW36Subset('__preW36RefreshOverWeakPlayerIds', playerId);
// PX — обновление рынка ради замены слабой текущей политики на цель из топ-3
export const isPreW36PolicyReplacePlayer = (playerId) => isInW36Subset('__preW36PolicyReplacePlayerIds', playerId);

// A/B волны 37 (боты «золото+»: оборона городов — доход бонуса с 29.10 идет за
// каждый город; режим харнесса SIM_W37). Поведение волны действует только у
// ботов золото+ (checkIfW36GoldPlusPlayer + checkIfW36Feature в
// evaluation/goldPlus.js), здесь — только legacy-наборы A/B. Игрок из набора
// своего признака играет ПРЕЖНИМ поведением этой подчасти; зонтичный набор
// __preW37PlayerIds — legacy по всем подчастям сразу. В продакшене наборы не
// заданы: новое поведение у всех ботов золото+.
const isInW37Subset = (setName, playerId) => Boolean(
  (globalThis.__preW37PlayerIds && globalThis.__preW37PlayerIds.has(playerId))
  || (globalThis[setName] && globalThis[setName].has(playerId))
);
// T — найм по угрозе городу в ЭТОМ раунде: отряды еще не ходивших противников и
// их возможный найм (кавалерия и пехота на свободной казарме, которые дойдут до
// кварталов города в том же ходу); заслон — и сверх общего потолка армии
export const isPreW37ThreatHirePlayer = (playerId) => isInW37Subset('__preW37ThreatHirePlayerIds', playerId);
// F — траты запаса монет на оборону фронтирных городов: слоты армии сверх
// общего потолка при большом запасе — под казармы открытых городов без держателя
export const isPreW37FrontierHirePlayer = (playerId) => isInW37Subset('__preW37FrontierHirePlayerIds', playerId);
// E — дорогие отряды при большом запасе монет
export const isPreW37RichUnitsPlayer = (playerId) => isInW37Subset('__preW37RichUnitsPlayerIds', playerId);
// A — найм на казармах у лагеря и в городах с арсеналом, найм с докупкой размера
export const isPreW37CampArsenalHirePlayer = (playerId) => isInW37Subset('__preW37CampArsenalHirePlayerIds', playerId);
// B1 — без угрозы в этом раунде отряд не уходит с казармы на кварталы своего
// города (теряет рост в снабжении)
export const isPreW37BarracksStayPlayer = (playerId) => isInW37Subset('__preW37BarracksStayPlayerIds', playerId);
// B2 — стояние на казарме, смежной лагерю (рост 4 вместо 2), по реальной
// разнице роста, а не до порога 80% размера
export const isPreW37CampHoldPlayer = (playerId) => isInW37Subset('__preW37CampHoldPlayerIds', playerId);

// A/B волны 38 (общий потолок армии бота по его лиге, configs/botArmyCap; режим
// харнесса SIM_W38). Игрок из набора своего признака играет ПРЕЖНИМ потолком 4;
// зонтичный набор __preW38PlayerIds — то же для всей волны. В продакшене наборы не
// заданы: потолок по лиге у всех явных ботов и ботов локальной партии (у неявных
// лиги нет — потолок и так прежний). Подчасть P (план стройки и резервы под
// потолок лиги) по A/B отчета 36 вредила вместе с C и удалена вместе с гейтом
// isPreW38PlanCapPlayer
const isInW38Subset = (setName, playerId) => Boolean(
  (globalThis.__preW38PlayerIds && globalThis.__preW38PlayerIds.has(playerId))
  || (globalThis[setName] && globalThis[setName].has(playerId))
);
// C — потолок армии в найме: новый отряд, заслон и держатель, проверка стройки
// «наймется ли держатель», «свободные слоты» инсектоидов и порог слотов F
export const isPreW38HireCapPlayer = (playerId) => isInW38Subset('__preW38HireCapPlayerIds', playerId);

// A/B волны 39 (боты за великанов, суккубов и гоблинов — фракционная игра по
// developer_artifacts/bot_strategy/faction_strategy; режим харнесса SIM_W39).
// Игрок из набора играет своей фракцией ОБЩИМ кодом ботов, как до волны: без
// найма «только великаны», соблазнения, ловушек и повреждения строений. В
// продакшене набор не задан: фракционная игра у всех ботов этих фракций
export const isPreW39FactionPlayer = (playerId) =>
  Boolean(globalThis.__preW39FactionPlayerIds && globalThis.__preW39FactionPlayerIds.has(playerId));

// A/B волны 40 (усиление великанов, отчет 38, режим харнесса
// SIM_W40_FLAGS). Игрок из набора своего признака играет как после волны 39. В
// продакшене наборы не заданы
const isInW40Subset = (setName, playerId) => Boolean(globalThis[setName] && globalThis[setName].has(playerId));
// V1 — великаны без пакета «сильные города» волны 33
export const isPreW40V1Player = (playerId) => isInW40Subset('__preW40V1PlayerIds', playerId);
// V3 — крупные великаны идут в бой и к чужим городам
export const isPreW40V3Player = (playerId) => isInW40Subset('__preW40V3PlayerIds', playerId);

// A/B волны 42 (боты за селестиалов, отчет 41, режим харнесса SIM_W40_FLAGS). Игрок из
// набора признака играет общим кодом ботов. В продакшене наборы не заданы
// C1 — ожидаемый урон по 4 костям в расчетах ближнего боя
export const isPreW42C1Player = (playerId) => isInW40Subset('__preW40C1PlayerIds', playerId);
// C2 — переброс из 4 костей
export const isPreW42C2Player = (playerId) => isInW40Subset('__preW40C2PlayerIds', playerId);
// C3 — расстояния в перемещении напрямую над горами
export const isPreW42C3Player = (playerId) => isInW40Subset('__preW40C3PlayerIds', playerId);
// U1 — кавалерия в найме: у летуна дальность 4 работает в любую сторону
export const isPreW42U1Player = (playerId) => isInW40Subset('__preW40U1PlayerIds', playerId);
// R1 — штурмовая игра: архетип раша, доктрина и атака нейтралов как у агрессивных фракций
export const isPreW42R1Player = (playerId) => isInW40Subset('__preW40R1PlayerIds', playerId);
